/* eslint-disable */
// AUTO-GENERATED by scripts/codegen/generate.mjs from wix.isa.task.v1 — do not edit.

import { resolveUrl, toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
const _task = {
  createdDate: 'google.protobuf.Timestamp',
  updatedDate: 'google.protobuf.Timestamp'
};
const _createTaskRequest = {
  task: '_task'
};
const _createTaskResponse = {
  task: '_task'
};
const _getTaskRequest = {};
const _getTaskResponse = {
  task: '_task'
};
const _updateTaskRequest = {
  task: '_task',
  fieldMask: 'google.protobuf.FieldMask'
};
const _updateTaskResponse = {
  task: '_task'
};
const _deleteTaskRequest = {};
const _deleteTaskResponse = {};
const _queryTasksRequest = {};
const _queryTasksResponse = {
  tasks: '_task'
};
const _searchTasksRequest = {};
const _searchTasksResponse = {
  tasks: '_task'
};
const _bulkCreateTasksRequest = {
  tasks: '_task'
};
const _bulkTaskResult = {
  task: '_task'
};
const _bulkCreateTasksResponse = {
  results: '_bulkTaskResult'
};
const _deleteMyTasksRequest = {};
const _deleteMyTasksResponse = {};
const _getLatestRoutineTaskSequenceRequest = {};
const _getLatestRoutineTaskSequenceResponse = {
  tasks: '_task'
};
const _appendTaskLogsRequest = {};
const _appendTaskLogsResponse = {};
const _appendParticipantNoteRequest = {};
const _appendParticipantNoteResponse = {};
const _appendNoteRequest = {};
const _appendNoteResponse = {};
const _descriptors = {
  _task,
  _createTaskRequest,
  _createTaskResponse,
  _getTaskRequest,
  _getTaskResponse,
  _updateTaskRequest,
  _updateTaskResponse,
  _deleteTaskRequest,
  _deleteTaskResponse,
  _queryTasksRequest,
  _queryTasksResponse,
  _searchTasksRequest,
  _searchTasksResponse,
  _bulkCreateTasksRequest,
  _bulkTaskResult,
  _bulkCreateTasksResponse,
  _deleteMyTasksRequest,
  _deleteMyTasksResponse,
  _getLatestRoutineTaskSequenceRequest,
  _getLatestRoutineTaskSequenceResponse,
  _appendTaskLogsRequest,
  _appendTaskLogsResponse,
  _appendParticipantNoteRequest,
  _appendParticipantNoteResponse,
  _appendNoteRequest,
  _appendNoteResponse
};
function resolveTaskServiceUrl(opts) {
  const domainToMappings = {
    'manage._base_domain_': [{
      srcPath: '/_api/task',
      destPath: ''
    }]
  };
  return resolveUrl(Object.assign(opts, {
    domainToMappings
  }));
}

/** CreateTask. */
export function createTask(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_createTaskRequest, _descriptors);
  const fromRes = serializer(_createTaskResponse, _descriptors).fromJSON;
  function __createTask(_ref) {
    let {
      host
    } = _ref;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'POST',
      methodFqn: 'wix.isa.task.v1.TaskService.CreateTask',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __createTask.fromReq = fromReq;
  __createTask.__isAmbassador = true;
  return __createTask;
}

/** GetTask. */
export function getTask(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_getTaskRequest, _descriptors);
  const fromRes = serializer(_getTaskResponse, _descriptors).fromJSON;
  function __getTask(_ref2) {
    let {
      host
    } = _ref2;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'GET',
      methodFqn: 'wix.isa.task.v1.TaskService.GetTask',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/{task_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __getTask.fromReq = fromReq;
  __getTask.__isAmbassador = true;
  return __getTask;
}

/** UpdateTask. */
export function updateTask(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_updateTaskRequest, _descriptors);
  const fromRes = serializer(_updateTaskResponse, _descriptors).fromJSON;
  function __updateTask(_ref3) {
    let {
      host
    } = _ref3;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'PATCH',
      methodFqn: 'wix.isa.task.v1.TaskService.UpdateTask',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/{task.id}',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __updateTask.fromReq = fromReq;
  __updateTask.__isAmbassador = true;
  return __updateTask;
}

/** DeleteTask. */
export function deleteTask(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_deleteTaskRequest, _descriptors);
  const fromRes = serializer(_deleteTaskResponse, _descriptors).fromJSON;
  function __deleteTask(_ref4) {
    let {
      host
    } = _ref4;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'DELETE',
      methodFqn: 'wix.isa.task.v1.TaskService.DeleteTask',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/{task_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __deleteTask.fromReq = fromReq;
  __deleteTask.__isAmbassador = true;
  return __deleteTask;
}

/** QueryTasks. */
export function queryTasks(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_queryTasksRequest, _descriptors);
  const fromRes = serializer(_queryTasksResponse, _descriptors).fromJSON;
  function __queryTasks(_ref5) {
    let {
      host
    } = _ref5;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'POST',
      methodFqn: 'wix.isa.task.v1.TaskService.QueryTasks',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/query',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __queryTasks.fromReq = fromReq;
  __queryTasks.__isAmbassador = true;
  return __queryTasks;
}

/** SearchTasks. */
export function searchTasks(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_searchTasksRequest, _descriptors);
  const fromRes = serializer(_searchTasksResponse, _descriptors).fromJSON;
  function __searchTasks(_ref6) {
    let {
      host
    } = _ref6;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'POST',
      methodFqn: 'wix.isa.task.v1.TaskService.SearchTasks',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/search',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __searchTasks.fromReq = fromReq;
  __searchTasks.__isAmbassador = true;
  return __searchTasks;
}

/** BulkCreateTasks. */
export function bulkCreateTasks(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_bulkCreateTasksRequest, _descriptors);
  const fromRes = serializer(_bulkCreateTasksResponse, _descriptors).fromJSON;
  function __bulkCreateTasks(_ref7) {
    let {
      host
    } = _ref7;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'POST',
      methodFqn: 'wix.isa.task.v1.TaskService.BulkCreateTasks',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/bulk/tasks/create',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __bulkCreateTasks.fromReq = fromReq;
  __bulkCreateTasks.__isAmbassador = true;
  return __bulkCreateTasks;
}

/** DeleteMyTasks. */
export function deleteMyTasks(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_deleteMyTasksRequest, _descriptors);
  const fromRes = serializer(_deleteMyTasksResponse, _descriptors).fromJSON;
  function __deleteMyTasks(_ref8) {
    let {
      host
    } = _ref8;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'POST',
      methodFqn: 'wix.isa.task.v1.TaskService.DeleteMyTasks',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/delete-my-tasks',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __deleteMyTasks.fromReq = fromReq;
  __deleteMyTasks.__isAmbassador = true;
  return __deleteMyTasks;
}

/** GetLatestRoutineTaskSequence. */
export function getLatestRoutineTaskSequence(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_getLatestRoutineTaskSequenceRequest, _descriptors);
  const fromRes = serializer(_getLatestRoutineTaskSequenceResponse, _descriptors).fromJSON;
  function __getLatestRoutineTaskSequence(_ref9) {
    let {
      host
    } = _ref9;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'GET',
      methodFqn: 'wix.isa.task.v1.TaskService.GetLatestRoutineTaskSequence',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/routine-latest-task-sequence',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __getLatestRoutineTaskSequence.fromReq = fromReq;
  __getLatestRoutineTaskSequence.__isAmbassador = true;
  return __getLatestRoutineTaskSequence;
}

/** AppendTaskLogs. */
export function appendTaskLogs(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_appendTaskLogsRequest, _descriptors);
  const fromRes = serializer(_appendTaskLogsResponse, _descriptors).fromJSON;
  function __appendTaskLogs(_ref0) {
    let {
      host
    } = _ref0;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'POST',
      methodFqn: 'wix.isa.task.v1.TaskService.AppendTaskLogs',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/{task_id}/append-logs',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __appendTaskLogs.fromReq = fromReq;
  __appendTaskLogs.__isAmbassador = true;
  return __appendTaskLogs;
}

/** AppendParticipantNote. */
export function appendParticipantNote(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_appendParticipantNoteRequest, _descriptors);
  const fromRes = serializer(_appendParticipantNoteResponse, _descriptors).fromJSON;
  function __appendParticipantNote(_ref1) {
    let {
      host
    } = _ref1;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'POST',
      methodFqn: 'wix.isa.task.v1.TaskService.AppendParticipantNote',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/{task_id}/append-participant-note',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __appendParticipantNote.fromReq = fromReq;
  __appendParticipantNote.__isAmbassador = true;
  return __appendParticipantNote;
}

/** AppendNote. */
export function appendNote(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_appendNoteRequest, _descriptors);
  const fromRes = serializer(_appendNoteResponse, _descriptors).fromJSON;
  function __appendNote(_ref10) {
    let {
      host
    } = _ref10;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.task',
      method: 'POST',
      methodFqn: 'wix.isa.task.v1.TaskService.AppendNote',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolveTaskServiceUrl({
        protoPath: '/v1/tasks/{task_id}/append-note',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __appendNote.fromReq = fromReq;
  __appendNote.__isAmbassador = true;
  return __appendNote;
}
//# sourceMappingURL=taskHttpRequests.js.map